<template>
  <section class="colorclarityblock">
    <div class="colorBlock" v-if="['sidecolor', 'avgColor'].includes(props?.boxValue)">

      <div class="title_block">
        <h3 v-if="colorLabel" class="mb-0 font-active">
          {{ colorLabel }} :
          <span v-if="formattedCenterColorStone">{{ formattedCenterColorStone }}</span>
          <span v-else>{{ resolvedColor }}</span><br>
        </h3>

      </div>
      <div v-if="(props?.boxValue === 'avgColor' && props?.detailData.sub_type === 'hues-ring') || (props?.boxValue === 'avgColor' && props?.detailData.sub_type === 'soiree-earring')" class="mt-3">
        <p class="mb-2">A diamond’s color is understood differently depending on whether you are looking at a colorless
          diamond or a fancy-colored diamond.
        </p>
        <p class="mb-2">
          <b>Colorless Diamonds</b><br>
          Diamond color refers to the absence of color within a diamond and is measured on a scale of D-Z, with D
          referring to the most colorless diamond and Z representing the least colorless diamond.
        </p>

        <p class="mb-2">Our jewelry features F-G color graded center and accent diamonds that appear colorless or
          near-colorless to the naked eye.</p>

        <p class="mb-2">

          <b>Fancy-Colored Diamonds</b><br>
          In a fancy colored diamond, color is its most defining and valuable feature. It refers to the diamond's hue
          (such as pink, blue, or yellow), tone (lightness or darkness), and saturation (intensity of the color).
        </p>

        <!-- <div class="image_block my-3 text-center" v-if="colorList?.length">
              <div v-for="color in colorList" :key="color" class="d-inline-block mx-2">
                  <img width="180" height="72" :src="'/settingactive/' + lowercase(color) + '.svg'"
                      :alt="color" />
              </div>
          </div> -->

        <p class="mb-0">
          Fancy colored diamonds are more desirable and valuable when their color is intense and vivid.</p>
      </div>
      <div class="mt-3" v-else-if="props?.boxValue === 'avgColor' && route.params.type === 'soiree-cocktail-jewellery'">
        <p class="mb-0">
          A diamond’s color grade measures the absence of color present in a diamond.
        Colorless diamonds let more light pass through than colored diamonds leading to more fire and sparkle.
        </p>

        <ModalImageScroll :item="resolvedColor" ref="scroller" :colorClarityBox="boxValue" />

        <!-- <p class="mb-0">Our {{ $t('jewelry') }} features F-G color graded center and accent diamonds
          that appear colorless or near-colorless to the naked eye.
        </p> -->
      </div>
      <div class="mt-3" v-else>
        <p class="mb-0">
          A diamond’s color is understood differently depending on whether you are looking at a colorless diamond or a
          fancy-colored diamond.
        </p>

        <ModalImageScroll :item="resolvedColor" ref="scroller" :colorClarityBox="boxValue" />
        <!-- highlight vs1 & vs2 inplace of vs  sliders of inithorizontal-->
        <p class="mb-0">Our {{ $t('jewelry') }} features F-G color graded center and accent diamonds
          that appear colorless or near-colorless to the naked eye.
        </p>
      </div>

    </div>

    <div class="clarityBlock" v-if="props?.boxValue === 'sideclarity' || props?.boxValue === 'avgClarity'">

      <div class="title_block">
        <h3 v-if="clarityLabel" class="mb-0 font-active">
          {{ clarityLabel }}:
          <span>{{ resolvedClarity }}</span>
        </h3>
      </div>

      <div class="mt-3 clarity_content">
        <p class="mb-0">A diamond’s clarity is determined by how flawless the diamond is. The more
          inclusions and blemishes a diamond has,
          the lower its clarity will be.
          The clarity ranges from ‘Flawless’ to ‘Included’.
        </p>
        <div class="text-center">
          <ModalImageScroll :detailData="detailData" :item="resolvedClarity" ref="scroller"
            :moduleSubType="moduleSubType" :complete="complete" :presetsubtype="presetsubtype"
            :colorClarityBox="boxValue" />
        </div>
        <p class="mb-0">
          Our {{ $t('jewelry') }} features VS1-VS2 (Very Slightly Included) clarity graded center and accent diamonds
          that contain inclusions that are virtually undetectable to the naked eye.
        </p>
      </div>

    </div>
  </section>
</template>

<script setup>
// const flagShowModal = ref(false);
const props = defineProps(['item', 'title', 'moduleSubType', 'currentMetal', 'type', 'detailData', 'complete', 'colorClarityBox', 'currentColor', 'currentClarity', 'boxValue', 'presetsubtype'])
// console.log(props,'inside colorClarityBox');
const route = useRoute();

// const moduleSubType = computed(() => route.meta.moduleSubType);
const presetClarity = props?.item?.d_clarity;

const scroller = ref(null);

const combinedColors = computed(() => {
  return (
    props.item?.center_color_stone_d_color ||
    props.item?.side_color_stone_d_color ||
    ''
  );
}); const colorList = computed(() => {
  return combinedColors.value
    ? combinedColors.value.split(',').map((color) => color.trim())
    : [];
});
const lowercase = (value) => {
  return value?.toLowerCase().replace(/[^\w]/gi, '');
};

// Shared constants for reusability
const ringSubTypes = [
  'band-ring',
  'full-eternity-ring',
  'anniversary-ring',
  'toi-et-moi-ring',
  'couple-bands-ring',
];

const otherSubTypes = [
  'tennis-bracelet',
  'fashion-bracelet',
  'openable-bangle',
  'fashion-earring',
  'fashion-necklace',
  'hoop-earring',
  'solitaire-necklace',
  'tennis-necklace',
  'stud-earring',
  'roses-portraits-ring',
  'initial-necklace'
];

// Computed properties
const colorLabel = computed(() => {
  if (props?.boxValue === 'avgColor') {
    return 'Diamond Color';
  }
  const isPrimaryRing =
    props?.moduleSubType === 'ring' ||
    props?.presetsubtype === 'preset' ||
    props?.detailData?.sub_type === 'in-stock-ring' ||
    props?.detailData?.sub_type === 'ring' ||
    props?.detailData?.sub_type === 'soiree-ring' ||
    props?.detailData?.sub_type === 'hues-ring' ||
    props?.detailData?.sub_type === 'in-stock-pendant' ||
    props?.detailData?.sub_type === 'in-stock-earring' ||
    ['earring', 'pendant', 'ring'].includes(props?.complete);

  const isExcludedRing = ringSubTypes.includes(props?.detailData?.sub_type);
  const isOtherType = otherSubTypes.includes(props?.detailData?.sub_type || route.params.type);
  const isPendantOrEarring = ['pendant', 'earring'].includes(props?.moduleSubType);

  if (isPrimaryRing && !isPendantOrEarring && !isExcludedRing) {
    return 'Side Stone Color';
  } else if (isExcludedRing || isOtherType) {
    return 'Average Color';
  } else if (isPendantOrEarring) {
    return 'Accent Stone Color';
  }

  return '';
});

const clarityLabel = computed(() => {
  if (props?.boxValue === 'avgClarity') {
    return 'Diamond Clarity';
  }
  const isPrimaryRing =
    props?.moduleSubType === 'ring' ||
    props?.detailData?.sub_type === 'in-stock-ring' ||
    props?.detailData?.sub_type === 'soiree-ring' ||
    props?.detailData?.sub_type === 'hues-ring' ||
    props?.detailData?.sub_type === 'ring' ||
    props?.detailData?.sub_type === 'in-stock-pendant' ||
    props?.detailData?.sub_type === 'in-stock-earring' ||
    props?.presetsubtype === 'preset' ||
    ['earring', 'pendant', 'ring'].includes(props?.complete);

  const isExcludedRing = ringSubTypes.includes(props?.detailData?.sub_type);
  const isOtherType = otherSubTypes.includes(props?.detailData?.sub_type);
  const isPendantOrEarring = ['pendant', 'earring','roses-portraits-ring'].includes(props?.moduleSubType || route.params.type);

  if (isPrimaryRing && !isPendantOrEarring && !isExcludedRing) {
    return 'Side Stone Clarity';
  } else if (isExcludedRing || isOtherType) {
    return 'Average Clarity';
  } else if (isPendantOrEarring) {
    return 'Accent Stone Clarity';
  }

  return '';
});
const resolvedColor = computed(() =>
  props?.currentColor || props?.item?.d_color || props?.item?.center_normal_stone_d_color
);
const resolvedClarity = computed(() => props?.currentClarity || props?.presetClarity || props?.item?.center_normal_stone_d_clarity || props?.item?.d_clarity || props?.item?.center_color_stone_d_clarity);

const formattedCenterColorStone = computed(() => {
  const colorStone = props?.item?.center_color_stone_d_color || props?.item?.side_color_stone_d_color;
  const resolved = resolvedColor?.value;
  // console.log("center_color_stone_d_color:", props?.item?.center_color_stone_d_color);
  // console.log("side_color_stone_d_color:", props?.item?.side_color_stone_d_color);
  // console.log("Selected colorStone:", colorStone);
  // console.log("Resolved Color:", resolved);

  const result = resolved && colorStone ? `${resolved}, ${colorStone}` : resolved || colorStone;

  // console.log("Final Computed Value:", result);

  return result;
});

onMounted(() => {

  setTimeout(() => {
    scroller.value?.scrollToHighlightedImage();

  }, 100)

});

</script>



<style scoped>
.highlight {
  color: #668b84;
  font-weight: bold;
  text-decoration: underline;
}

.largesvg {
  transform: scale(1.3);
}

.images {
  display: flex;
  overflow-x: auto;
  gap: 16px;
  align-items: center;
  cursor: pointer;
}

.fancyImages {
  display: flex;
  justify-content: center;
  align-items: center;
}

.images .box {
  flex: 0 0 auto;
  width: auto;
  text-align: center;
  user-select: none;
}

.pop_open {
  color: #cccccc;
  font-size: 14px;
  cursor: pointer;
}

.title_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
}


p {
  font-size: 16px;
  color: #606060;
}

.title_block span {
  cursor: pointer;
  color: var(--green);
}

h3 {
  font-size: 22px;
}

.box {
  width: 25%;
}

.m-info {
  margin: 10px 0;
}


/* -----scroll--------- */
/* width */
.images::-webkit-scrollbar {
  width: 5px;
  height: 3px;
}

/* Track */
.images ::-webkit-scrollbar-track {
  background: #f5f5f5;
}

/* Handle */
.images::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  cursor: pointer;
}

/* Handle on hover */

/* -----scroll--------- */
@media(max-width: 767px) {
  h3 {
    font-size: 20px;
  }

  p {
    font-size: 14px;
  }

}
</style>
